module.exports = __webpack_public_path__ + "static/media/hang-up.1b1f0dc8.svg";